<template>
  <v-container fluid class="fill-height pa-0">
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" lg="4" style="max-width:500px" class="ma-auto pa-10">
        <v-card outlined :loading="loading">
          <div class="px-4 pt-6 pb-12 justify-center">
            <div class="v-application justify-center">
              <img class="logo" src="/_logo.png" />
            </div>

            <v-card-title class="justify-center">
              Hoşgeldin !
            </v-card-title>
            <v-card-subtitle class="justify-center">
              <div class="v-application  justify-center">
                <p class="text-muted">gostore için giriş yap.</p>
              </div>
            </v-card-subtitle>
            <v-alert v-if="otpTimeOutAlert" color="error">
              OTP şifresi için ayrılan süre doldu, lütfen yeniden giriş yapınız.
            </v-alert>
            <v-card-text v-if="stage == 1">
              <!-- <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }"> -->
              <!-- <form @submit.prevent="handleSubmit(signin)" @reset.prevent="reset"> -->
              <ValidationProvider v-slot="{ errors }" name="Email" rules="required">
                <v-text-field v-model="email" @keydown.enter="signin" :error-messages="errors" label="Kullanıcı Adı"
                  filled prepend-inner-icon="mdi-account-outline"></v-text-field>
              </ValidationProvider>
              <ValidationProvider v-slot="{ errors }" name="Şifre" rules="required">
                <v-text-field v-model="sec" @keydown.enter="signin" type="password" :error-messages="errors"
                  label="Şifre" filled prepend-inner-icon="mdi-lock-outline"></v-text-field>
              </ValidationProvider>
              <div class="mt-6 d-flex justify-center">
                <v-btn @click="signin" class="primary" :loading="loading" depressed>devam</v-btn>
              </div>
              <!-- </form> -->
              <!-- </ValidationObserver> -->
            </v-card-text>
            <div class="d-flex justify-center" v-if="stage == 2">
              <div>
                <div class="d-flex justify-center">
                  Lütfen OTP doğrulama kodunu giriniz
                </div>
                <br />
                <v-text-field v-model="otp" @keydown.enter="signin" :error-messages="errors" label="OTP Şifresi" filled
                  prepend-inner-icon="mdi-cellphone-key"></v-text-field>
                <div class="mt-6 d-flex justify-center">
                  <v-btn class="success" @click="signin" :loading="loading" depressed>GİRİŞ({{ timer }})</v-btn>
                </div>
              </div>
            </div>

          </div>
        </v-card>

        <div class="mt-5 text-center">


          <img class="logo" style="max-height:30px" src="/logo.png" />
          <p>
            © {{ new Date().getFullYear() }}
          </p>
        </div>

      </v-col>

    </v-row>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <v-btn color="white" text @click="snackbar = false" icon>
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>

import AuthenticationService from '../../services/AuthenticationService'

export default {
  name: 'SignIn',
  data: () => ({
    email: '',
    sec: '',
    loading: false,
    otp: '',
    stage: 1,
    snackbar: false,
    snackbarText: '',
    timer: 150,
    otpStatus: true,
    otpLength: 6,
    otpTimeOutAlert: false,
    errors: []
  }),
  methods: {
    async getOtpStatus() {
      try {
        const data = await AuthenticationService.getOtpStatus()
        if (data && data.data)
          this.otpStatus = data.data.data.status
        this.otpLength = data.data.data.length
      } catch (error) {
        alert('OTP Status could not be fetched.')
        alert(error)
      }
    },
    async signin() {
      if (this.otpStatus == true) {
        this.signinWithOtp()
      }
      else {
        this.signinWithoutOtp()
      }
    },
    async signinWithoutOtp() {
      if (this.loading) return
      this.loading = true

      const data = await this.$store
        .dispatch('signIn', { email: this.email, sec: this.sec })
        .catch((err) => {
          this.loading = false
          if (err.message && err.message.indexOf('429') > -1) {
            this.showSnackBar('Çok fazla giriş denemesi yapıldı. Lütfen 10 dakika sonra tekrar deneyiniz.')
          }
          else {
            this.showSnackBar('Kullanıcı adı veya şifre hatalı, tekrar deneyiniz.')
          }
        })

      if (!data) return
      const user = await this.$store
        .dispatch('getCurrentUser', data.token)
        .catch((err) => alert(err))

      if (!user) return

      this.loading = false

      //Go to '/defaultpath' if no redirectPath value is set
      this.$router.push(sessionStorage.getItem('redirectPath') || '/');

      //Cleanup redirectPath
      sessionStorage.removeItem('redirectPath');

    },
    async signinWithOtp() {
      if (this.loading) return
      this.loading = true

      if (this.stage == 1) {

        this.otpTimeOutAlert = false

        let data = await AuthenticationService.signIn({ email: this.email, sec: this.sec, stage: this.stage, otp: this.otp.trim() })
          .catch((err) => {
            this.loading = false
            if (err.message && err.message.indexOf('429') > -1) {
              this.showSnackBar('Çok fazla giriş denemesi yapıldı. Lütfen 10 dakika sonra tekrar deneyiniz.')
            }
            else {
              this.showSnackBar('Kullanıcı adı veya şifre hatalı, tekrar deneyiniz.')
            }

          })
          .finally(() => {
          })

        if (!data || !data.data) return

        data = data.data;

        if (data.data && data.data.status == 'waitingotp') {
          this.stage = 2
          this.loading = false
          this.setTimer()
          return
        }
      }
      else {
        const data = await this.$store
          .dispatch('signIn', { email: this.email, sec: this.sec, stage: this.stage, otp: this.otp.trim() })
          .catch((err) => {
            this.loading = false
            this.otp = ''
            if (err.message && err.message.indexOf('429') > -1) {
              this.showSnackBar('Çok fazla giriş denemesi yapıldı. Lütfen 10 dakika sonra tekrar deneyiniz.')
            }
            else {
              this.showSnackBar('OTP kodu doğrulanamadı, lütfen tekrar deneyiniz.')
            }

          })

        if (!data) return
        const user = await this.$store
          .dispatch('getCurrentUser', data.token)
          .catch((err) => alert(err))

        if (!user) return

        this.loading = false

        //Go to '/defaultpath' if no redirectPath value is set
        this.$router.push(sessionStorage.getItem('redirectPath') || '/');

        //Cleanup redirectPath
        sessionStorage.removeItem('redirectPath');
      }
    },
    setTimer() {
      this.timer -= 1
      if (this.timer == 0) {
        this.stage = 1
        this.timer = 150
        this.showSnackBar('OTP giriş süreniz doldu, lütfen yeniden giriş yapınız.')
        this.otpTimeOutAlert = true
      }
      else {
        setTimeout(() => {
          this.setTimer()
        }, 1000);
      }
    },
    showSnackBar(text) {
      this.loading = false
      this.snackbarText = text
      this.snackbar = true
      if (this.stage == 1) {
        this.email = ''
        this.sec = ''
      }
      else {
        this.otp = ''
      }
    }
  },
  mounted() {
    this.getOtpStatus()
  }

}
</script>

<style>
.auth-body-bg {
  background-color: $card-bg;
}

.authentication-bg {
  background-image: url("/loginbackground.jpg");
  height: 100vh;
  background-size: cover;
  background-position: center;
}

.bg-overlay {
  background-color: #292626;
}

.logo {
  max-height: 50px;
}

.otpDiv {
  width: 80%;

  padding: 0px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
</style>
